import { Messages } from '../../codegen/Localize';
import { ValidTelemetryEvent, Telemetry } from '../../commonInfra/services/Telemetry';

// List of User Notifications telemetry events. Each event corresponds to its own table in GBQ under the UserNotificationsPlatformEvents event family.
export enum UserNotificationsTelemetryEvents {
  openNotificationCenter = 'notification_center_open',
  closeNotificationCenter = 'notification_center_close',
  markAllAsRead = 'notification_panel_header_mark_all_as_read',
  clickUserSettingsLink = 'notification_panel_header_user_settings_link',
  changeTabs = 'notification_panel_tab_change',
  clickNotificationItem = 'notification_item_click',
  notificationItemAction = 'notification_item_action',
  notificationCenterPerfLoadTime = 'notification_center_perf_load_time',
  markAllAsReadPerfLoadTime = 'notification_center_perf_mark_all_as_read_load_time'
}

export interface UserNotificationsCenterEvent extends ValidTelemetryEvent<UserNotificationsCenterEvent> {
  type: string;
  user_id: string;
  site_luid: string;
}

export interface UserNotificationsCenterPerfEvent extends ValidTelemetryEvent<UserNotificationsCenterEvent> {
  load_time: number;
  notification_count: number;
}

export interface UserNotificationsPanelEvent extends ValidTelemetryEvent<UserNotificationsCenterEvent> {
  tab_name: string;
}

export interface UserNotificationItemEvent extends ValidTelemetryEvent<UserNotificationsCenterEvent> {
  notification_type: string;
}

export interface UserNotificationItemActionEvent extends ValidTelemetryEvent<UserNotificationItemEvent> {
  action_type: string;
}


export function sendUserNotificationsCenterTelemetry(eventType: string, userId: string, siteLuid: string) {
  Telemetry.sendEvent<UserNotificationsCenterEvent>({
    type: eventType,
    user_id: userId,
    site_luid: siteLuid
  });
}

export function sendUserNotificationsCenterPerfTelemetry(eventType: string, userId: string, siteLuid: string, loadTime: number, notificationCount: number) {
  Telemetry.sendEvent<UserNotificationsCenterPerfEvent>({
    type: eventType,
    user_id: userId,
    site_luid: siteLuid,
    load_time: loadTime,
    notification_count: notificationCount
  });
}

export function sendUserNotificationsPanelTelemetry(eventType: string, userId: string, siteLuid: string, tabIndex: number) {
  const tabName = tabIndex === 0 ? Messages.userNotificationAllTabTitle() : Messages.userNotificationUnreadTabTitle();
  Telemetry.sendEvent<UserNotificationsPanelEvent>({
    type: eventType,
    user_id: userId,
    site_luid: siteLuid,
    tab_name: tabName
  });
}

export function sendUserNotificationItemTelemetry(eventType: string, userId: string, siteLuid: string, notificationType: string) {
  Telemetry.sendEvent<UserNotificationItemEvent>({
    type: eventType,
    user_id: userId,
    site_luid: siteLuid,
    notification_type: notificationType
  });
}

export function sendUserNotificationItemActionTelemetry(eventType: string, userId: string, siteLuid: string, notificationType: string, actionType: string) {
  Telemetry.sendEvent<UserNotificationItemActionEvent>({
    type: eventType,
    user_id: userId,
    site_luid: siteLuid,
    notification_type: notificationType,
    action_type: actionType
  });
}